<ng-container>
  <div class="page-title">
    <div [innerHTML]="'AddressInfo.First.Title' | translate | safe:'html'" class="title">
    </div>
    <div [innerHTML]="'AddressInfo.First.SubTitle' | translate | safe:'html'" class="sub-title">
    </div>
  </div>

  <app-address
    (addressModelChange)="updateUser()"
    [addressModel]="user.addressModel"
    [monitoring]="user.monitoring">
  </app-address>
</ng-container>

<ng-container>
  <div class="page-title">
    <div [innerHTML]="'CitizenshipInfo.First.Title' | translate | safe:'html'" class="title"></div>
    <div [innerHTML]="'CitizenshipInfo.First.SubTitle' | translate | safe:'html'" class="sub-title"></div>
  </div>

  <app-citizenship
    (citizenshipModelChange)="updateUser()"
    [citizenshipModel]="user.contactModel"
    [forbiddenIds]="[user.secondHolder.contactModel.idNumber]"
  >
  </app-citizenship>
</ng-container>
